export const Left = 1
export const Right = 2
